(() => {
  if (window.sevenSeasFooterStatus) { window.sevenSeasFooterStatus(); return; }
  const partsFor = date => Object.fromEntries(new Intl.DateTimeFormat('en-US', { timeZone:'America/New_York', weekday:'short',hour:'2-digit',minute:'2-digit',hourCycle:'h23' }).formatToParts(date).map(p=>[p.type,p.value]));
  const clock = hour => `${hour === 24 ? 12 : hour % 12 || 12} ${hour >= 12 && hour < 24 ? 'PM' : 'AM'}`;
  function update() {
    const p = partsFor(new Date());
    const minutes = Number(p.hour)*60+Number(p.minute);
    document.querySelectorAll('[data-ss-footer-status]').forEach(el => {
      const open = Number(el.dataset.open);
      const close = Number(p.weekday === 'Sun' ? el.dataset.sundayClose : el.dataset.close);
      if (!Number.isFinite(open) || !Number.isFinite(close)) return;
      const isOpen = el.dataset.override !== 'closed' && minutes >= open*60 && minutes < close*60;
      el.hidden = false;
      el.classList.toggle('is-closed',!isOpen);
      el.querySelector('[data-ss-status-label]').textContent = isOpen ? el.dataset.openLabel : el.dataset.closedLabel;
      el.querySelector('[data-ss-status-detail]').textContent = isOpen ? `${el.dataset.closesLabel} ${clock(close)}` : '';
    });
  }
  window.sevenSeasFooterStatus=update;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',update); else update();
  document.addEventListener('shopify:section:load',update);
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)update();});
  setInterval(update,60000);
})();
